import React from 'react';
import { useStyletron } from 'baseui';
import { Button } from 'baseui/button';
import { DataList, Loader, ConfirmationModal } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';

import useOpponentsDetails from './useOpponentsDetails';
import { columnConfigs } from './listConfig';
import DateRangeFilter from './DateRangeFilter';

const OpponentDetails: React.FC<{ isCollapsed: any }> = (props) => {
	const { isCollapsed } = props;
	const {
		getUserOpponentsData,
		handleFilterSubmit,
		forceUpdate,
		showLoader,
		downloadCsvFile,
		confirmation,
		confirmationDialogOnClose,
		confirmationDialogOnAgree
	} = useOpponentsDetails(isCollapsed);
	const [css] = useStyletron();

	return (
		<>
			{showLoader && <Loader />}
			<div>
				<div
					className={css({
						height: '60px',
						display: 'flex',
						alignItems: 'center',
						backgroundColor: 'white',
						paddingLeft: '10px',
						borderTop: '1px solid rgb(242, 242, 242)',
						gap: '850px'
					})}>
					<DateRangeFilter onSubmit={handleFilterSubmit} />
					<Button onClick={downloadCsvFile} kind='primary' size='compact'>
						Download CSV File
					</Button>
				</div>
				<DataList
					fetchData={getUserOpponentsData}
					columnConfigs={columnConfigs}
					hideActions
					rowHeight={50}
					entity={LIST_ENTITY_NAMES.OPPONENTS_DETAILS}
					globalForceUpdate={forceUpdate}
					height='calc(100vh - 220px)'
				/>
				{confirmation && (
					<ConfirmationModal
						confirmationHeader='Data Fetch Confirmation'
						confirmationMessage='This will take time, Do you want to continue ?'
						onClose={confirmationDialogOnClose}
						confirmationDialogOnAgree={confirmationDialogOnAgree}
					/>
				)}
			</div>
		</>
	);
};

export default OpponentDetails;
